import { gql } from 'graphql-request';

export const walletTransactionQuery = gql`
  query ($subdomain: String!) {
    walletTransactions(subdomain: $subdomain) {
      id
      amount
      transactionType
      transactionReason
      createdAt
    }
  }
`;
